module.exports = {
      id: "sun-usage",
      viewBox: "0 0 512 512",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#sun",
      toString: function () {
        return this.url;
      }
    }